var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeOfferBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1438,
    height: 610,
    viewBox: "0 0 1438 610",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1082 354.408C-27.4503 428.565 20.952 498.776 56.6631 536.367C77.863 556.611 133.55 604.553 167.747 579.276C186.29 560.811 188.926 536.016 194.934 513.661C205.388 479.163 206.144 440.187 229.204 409.098C279.031 374.58 270.905 534.603 291.512 553.405C319.385 580.049 339.676 490.138 328.613 477.292C327.334 473.266 321.656 470.813 317.09 473.383C311.2 476.775 313.518 485.166 315.222 490.187C321.136 507.014 353.001 554.429 380.128 541.997C399.228 527.162 397.331 504.138 409.633 486.044C418.407 469.534 441.435 465.18 459.859 474.811C610.699 541.885 795.05 549.269 946.314 477.595C976.789 465.084 1000.08 446.225 1034.82 441.437C1176.84 427.224 1282.59 537.378 1391.68 592.002C1430.81 612.511 1440.88 593.71 1441.34 560.609C1442.48 527.039 1440.46 494.122 1427.75 461.926C1398.76 380.588 1316.86 356.689 1237.24 313.98C1188.09 287.753 1117.82 200.218 1197.64 176.425C1231.41 163.951 1273.63 157.52 1306.36 149.757C1399.58 131.702 1436.47 74.5498 1431.52 0.3125L1446 0.693629C1445.46 51.3781 1430.76 87.5239 1404.37 113.03C1368.61 147.579 1297.41 155.406 1231.97 170.434C1208.77 175.21 1176.11 184.959 1167.73 204.846C1156.92 244.751 1198.84 289.872 1238.08 313.099C1330.44 362.446 1408.6 381.791 1436.81 478.934C1446.93 517.552 1479.58 644.668 1383.94 600.695C1271.91 550.466 1133.18 397.148 992.159 459.15C847.539 534.346 662.014 553.664 501.995 499.431C482.173 493.752 463.78 485.062 444.038 479.439C412.003 474.858 406.335 525.134 385.357 539.075C359.435 563.736 300.764 494.342 309.561 475.15C313.439 465.969 330.155 466.683 333.163 475.969C344.492 489.83 318.579 583.027 290.145 554.096C274.733 543.319 262.105 381.611 234.317 417.894C208.986 471.033 217.189 535.247 171.361 581.978C108.714 629.847 -103.511 445.699 31.9236 349.355L43.1082 354.408Z",
    fill: "url(#paint0_linear_31_23187)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_23187",
    x1: 1562.17,
    y1: 277.635,
    x2: 124.89,
    y2: -306.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF635F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A75894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4EC9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeOfferBg);
export default __webpack_public_path__ + "static/media/we-offer-bg.5bd2298b10605b4193a3addd08cfed5a.svg";
export { ForwardRef as ReactComponent };